import { BaseMessage } from './base.js';
export class PingMessage extends BaseMessage {
    payload;
    constructor(payload) {
        super(payload);
        this.payload = payload;
    }
    get serverTs() {
        return this.payload.serverTs;
    }
    get currentOffset() {
        return this.payload.currentOffset;
    }
}
